export default __webpack_public_path__ + "static/media/e4247e075768bccf334774fc569a37d9.svg";